import React from 'react'

import { reportDatadogError } from '@/lib/datadog'

class ComponentErrorBoundary extends React.Component<{
  children: React.ReactNode
  fallback: React.ReactNode
  logError?: boolean
}> {
  static defaultProps = {
    logError: true,
  }

  state = { hasError: false }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (!this.props.logError) {
      return
    }

    if (typeof window !== 'undefined') {
      reportDatadogError(
        error,
        {
          boundary: 'ComponentErrorBoundary',
          componentStack: errorInfo.componentStack,
          url: window.location.href,
        },
        `Markdown component failed to render: ${error.message}`,
      )
    }

    if (process.env.NODE_ENV !== 'production') {
      console.error(error)
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }
    return this.props.children
  }
}

export default ComponentErrorBoundary
